import { render } from "./ProduitsObsoletes.vue?vue&type=template&id=786b6ca6&scoped=true"
import script from "./ProduitsObsoletes.vue?vue&type=script&lang=js"
export * from "./ProduitsObsoletes.vue?vue&type=script&lang=js"

import "./ProduitsObsoletes.vue?vue&type=style&index=0&id=786b6ca6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786b6ca6"]])

export default __exports__